export default "__VITE_PUBLIC_ASSET__c406ca90__"